import { faChevronRight } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import classNames from 'classnames';
import Button from 'components/base/Button';
import { Form } from 'react-bootstrap';
import { useAuth } from 'providers/AuthProvider'
import { useTranslation } from 'react-i18next';
import { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import apiClient, { handleAPIError } from 'helpers/apiService';

const ForgotPasswordForm = ({
  layout
}: {
  layout?: 'simple' | 'card' | 'split';
}) => {


  const { t, i18n } = useTranslation();
  const navigate = useNavigate();
  const auth = useAuth();
  const [status, setStatus] = useState("");

  async function handleSubmit(event: React.FormEvent<HTMLFormElement>) {
    event.preventDefault();

    const formData = new FormData(event.currentTarget);
    const email = formData.get("email") as string;

    const resetForm = new FormData();
    resetForm.append('resetForm', JSON.stringify({
      'email': email,
    }));
    try {
      const response = await apiClient.post(
        '/auth/forget-password', resetForm,
        {
          headers: {
            'accept': 'application/json',
          }
        }
      );

      if (response.status === 200) {
        setStatus("check your inbox for new login credentials")

      }

    } catch (error) {
      const message = handleAPIError(error);
      if (message) {
        setStatus(message);
      } else {
        // Handle non-Axios errors
        console.error('Request failed:', error);
      }

    }



  }

  return (
    <div className={classNames({ 'px-xxl-5': !(layout === 'split') })}>
      <div
        className={classNames('text-center', { 'mb-6': !(layout === 'split') })}
      >
        <h4 className="text-1000">Forgot your password?</h4>
        <p className="text-700 mb-5">
          Enter your email below and we will send <br className="d-sm-none" />
          you a new password
        </p>
        <Form className="d-flex align-items-center mb-5" onSubmit={handleSubmit}>
          <Form.Control
            type="email"
            id="email"
            name="email"
            className="flex-1"
            placeholder="name@example.com"
          />
          <Button type="submit"
            variant="primary"
            className="ms-2"
            endIcon={<FontAwesomeIcon icon={faChevronRight} className="ms-2" />}
          >
            Send
          </Button>
        </Form>
        <Link to="#!" className="fs-9 fw-bold">
          Still having problems?
        </Link>

        <p className="text-700 mt-3 mb-3">
          {status}
        </p>

      </div>
    </div>
  );
};

export default ForgotPasswordForm;
